import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { DebtInquiriesComponent } from './debtinquiries.component';
import { FormPlycaModule } from '../components/forms/formPlyca.module';


@NgModule({
  declarations: [DebtInquiriesComponent],
  imports: [
    CommonModule,
    FormPlycaModule
  ]
})
export class DebtInquiriesModule { }
